import React from 'react';
import '../styles/skeleton.css';

const GroupRankingCardSkeleton = () => {
  return (
    <div className="ranking-card-skeleton">
      <div className="skeleton-main">
        {/* Rank skeleton */}
        <div className="skeleton-rank">
          <div className="skeleton-shimmer skeleton-box" style={{ width: '48px', height: '48px', borderRadius: '12px' }} />
        </div>

        {/* User info skeleton */}
        <div className="skeleton-user">
          <div className="skeleton-shimmer skeleton-circle" style={{ width: '44px', height: '44px' }} />
          <div className="skeleton-user-info">
            <div className="skeleton-shimmer skeleton-box" style={{ width: '120px', height: '16px', borderRadius: '4px', marginBottom: '6px' }} />
            <div className="skeleton-shimmer skeleton-box" style={{ width: '80px', height: '12px', borderRadius: '4px' }} />
          </div>
        </div>

        {/* Performance skeleton */}
        <div className="skeleton-performance">
          <div className="skeleton-shimmer skeleton-box" style={{ width: '70px', height: '18px', borderRadius: '4px', marginBottom: '6px', marginLeft: 'auto' }} />
          <div className="skeleton-shimmer skeleton-box" style={{ width: '60px', height: '14px', borderRadius: '4px', marginLeft: 'auto' }} />
        </div>

        {/* Action skeleton */}
        <div className="skeleton-action">
          <div className="skeleton-shimmer skeleton-box" style={{ width: '12px', height: '12px', borderRadius: '2px' }} />
        </div>
      </div>
    </div>
  );
};

export default GroupRankingCardSkeleton;
